import { CHCP_CONFIG, LOCAL_STORE } from "@/config/constConfig";

/**
 * 获取剪切板数据
 * 将数据存储到 LOCAL_STORE.CLIPBOARD_DATA
 */
async function getClipBoardData() {
    let result: any = await reqCordovaChcp(CHCP_CONFIG.REQ_CLIPBOARD_DATA, "");
    if (result) {
        localStorage.setItem(LOCAL_STORE.CLIPBOARD_DATA, result);
    }
}

/**
 * 获取adjust数据
 * 将数据存储到 LOCAL_STORE.ADJUST_DATA
 */
async function getAdjustData() {
    let result: any = await reqCordovaChcp(CHCP_CONFIG.REQ_GET_ADJUSTDATA, "");
    if (result) {
        localStorage.setItem(LOCAL_STORE.ADJUST_DATA, result);
    }
}

/**
 * 获取googleId
 * 将数据存储到 LOCAL_STORE.GOOGLE_ID
 */
async function getGoogleId() {
    let result: any = await reqCordovaChcp(CHCP_CONFIG.REQ_GET_GOOGLEID, "");
    if (result) {
        localStorage.setItem(LOCAL_STORE.GOOGLE_ID, result);
    }
}

/**
 * 获取包名
 * 将数据存储到 LOCAL_STORE.PACKAGE_NAME
 */
async function getPackageName(): Promise<any> {
    let result: any = await reqCordovaChcp(CHCP_CONFIG.REQ_PACKAGE_NAME, "");
    if (result) {
        localStorage.setItem(LOCAL_STORE.PACKAGE_NAME, result);
    }
}

/**
 * 更新屏幕方向
 * @param direction t:竖屏 l:横屏
 */
function changeScene(direction: any) {
    reqCordovaChcp(CHCP_CONFIG.REQ_CHANGE_SCENE, direction);
}

/**发送chcp请求 */
async function reqCordovaChcp(reqName: string, params: any): Promise<any> {
    return new Promise((resolve, reject)=> {
        console.log("reqName:", reqName, ", reqParams:", JSON.stringify(params));
        let tempChcp = getChcp();
        tempChcp.nativeCall(reqName, params, function (msg:string) {
            console.log("reqName: ",reqName," sucess =>>>>>>>>>>>>>", JSON.stringify(msg));
            resolve(msg)
        }, function (msg:string) {
            console.log("reqName: ",reqName," fail =>>>>>>>>>>>>>", msg);
        });
    })
}

function getChcp() {
    return (window as any).chcp;
}

export {
    reqCordovaChcp,
    getClipBoardData,
    getAdjustData,
    getGoogleId,
    getPackageName,
    changeScene
}